import http from '@/services/http'
import { userUrl } from '@/services/url'

// interface AuthTree {
//   resourceTree: any
// }

export const getAuthTree = async () => await http.admin.post(userUrl.authTree)
